export default __webpack_public_path__ + "b7a005bdfadf506f2026704537cbe89d.svg";